export default "__VITE_ASSET__948d3c29__"